import { Navigate, Route } from 'react-router';

export function getTaskManagerRoutes(hasTaskManagerV2Routes: boolean) {
  if (hasTaskManagerV2Routes) {
    return (
      <Route path="task-manager" id="tsk-root" lazy={() => import('routes/task-manager/task-manager.route')}>
        <Route index id="tsk-index" lazy={() => import('routes/task-manager/task-manager.index.route')} />
        <Route path="overview" id="tsk-overview" element={<Navigate to="/task-manager" replace />} />
        <Route path=":taskId" id="tsk-id" lazy={() => import('routes/task-manager/task-manager.$taskId.route')} />
        <Route
          path="resources/task-queue"
          id="tsk-queue"
          lazy={() => import('routes/task-manager/resources/task-queue')}
        />
        <Route
          path="resources/sub-task-queue/:taskId"
          id="tsk-sub-task-queue"
          lazy={() => import('routes/task-manager/resources/sub-task-queue')}
        />
      </Route>
    );
  }

  return (
    <Route path="task-manager" id="tsk-root" lazy={() => import('pages/task-manager/routes/task-manager')}>
      <Route index id="tsk-index" lazy={() => import('pages/task-manager/routes/task-manager.index')} />
      <Route path="overview" id="tsk-overview" lazy={() => import('pages/task-manager/routes/task-manager.overview')} />
      <Route path=":taskId" id="tsk-id" lazy={() => import('pages/task-manager/routes/task-manager.$taskId')} />
    </Route>
  );
}
